import React from "react";
import { Controller } from "react-hook-form";

import { Range } from "@/hooks/api/search/useInfiniteSearch";
import Checkbox from "@/components/atoms/Checkbox";
import FormControl, { FormControlProps } from "@/components/molecules/form/FormControl";

type FormRangeCheckboxesProps = {
  name: string;
  ranges: Range[];
  displayLabel: (from?: number, to?: number) => string;
} & Omit<FormControlProps, "id" | "children">;

const FormRangeCheckboxes = ({ name, ranges, displayLabel, ...controls }: FormRangeCheckboxesProps) => {
  return (
    <FormControl {...controls} id={name}>
      <div className="grid gap-2">
        {ranges.map((range, index) => {
          return (
            <Controller
              key={index}
              name={name}
              render={({ field: { onChange, value } }) => {
                const isChecked = value.some(
                  (selectedRange: Range) => selectedRange.min === range.min && selectedRange.max === range.max,
                );

                const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
                  if (e.target.checked) {
                    onChange([...value, range]);
                  } else {
                    onChange(
                      value.filter(
                        (selectedRange: Range) => !(selectedRange.min === range.min && selectedRange.max === range.max),
                      ),
                    );
                  }
                };

                return (
                  <label htmlFor={`${name}-range-${index}`} className="flex items-center gap-x-3">
                    <Checkbox id={`${name}-range-${index}`} checked={isChecked} onChange={handleChange} />
                    <span className={"font-medium text-secondary"}>{displayLabel(range.min, range.max)}</span>
                  </label>
                );
              }}
            />
          );
        })}
      </div>
    </FormControl>
  );
};

export default FormRangeCheckboxes;
